<template>
  <footer class="footer" id="footer">
    <img src="images/footer__icon.svg" alt="" class="footer__icon">
    <p class="footer__copy">©︎ 柴の宿 All Rights Reserved.</p>
  </footer>
</template>

